import { useSettings } from '@wu/widget-core';

export function useHasSubmissionForm() {
  const { resultButtonAction } = useSettings();

  return resultButtonAction === 'openForm';
}
